// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3gXvS","row":"ProcedureTreatmentSummary_row__2_DSN"};